export enum AnalysisMatingPregnancy {
    "WeaningToMating",
    "MatingToNonPregnant",
    "MatingToMating",
    "MatingToAbortionAndDeparture",
    "TotalMatings"
}